import React from 'react';
import ReactDOM from 'react-dom';
import GlobalContext from 'src/context';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <GlobalContext>
      <App />
    </GlobalContext>
  </React.StrictMode>,
  document.getElementById('root')
);
